import React from 'react';
import PropTypes from 'prop-types';
import SortArrows from '../__partials/sort-arrows';
import SelectMark from '../select-mark';
import classNames from 'classnames';

import './style.scss';

/* eslint-disable no-nested-ternary */
export default class DataTable extends React.Component {
  constructor(props) {
    super(props);

    if (props.columnDefaultSortIndex >= 0) {
      const i = props.columnDefaultSortIndex;
      this.state = {
        rows: this.sort(props.rows, i, props.columnDefaultSortDirection),
        sortedBy: props.columnDefaultSortIndex,
        sortDirection: props.columnDefaultSortDirection || 'ascending',
      };
    } else {
      this.state = {
        rows: props.rows,
        sortedBy: null,
        sortDirection: 'none',
      };
    }
  }

  componentWillReceiveProps(nextProps) {
    const i = this.state.sortedBy;
    const sortDirection = this.state.sortDirection;
    this.setState({
      rows: this.sort(nextProps.rows, i, sortDirection),
    });
  }

  sortBy = (i) => {
    let sortDirection;
    const ascending = this.state.sortDirection === 'ascending';
    if (i === this.state.sortedBy) {
      sortDirection = !ascending ? 'ascending' : 'descending';
    } else {
      sortDirection = 'ascending';
    }
    this.setState(prevState => ({
      rows: this.sort(prevState.rows, i, sortDirection),
      sortedBy: i,
      sortDirection: sortDirection,
    }));
  }

  sort = (rows, sortIndex, sortDirection) => {
    const i = sortIndex;
    return rows.sort((a, b) => {
      if (sortDirection === 'ascending') {
        if (isNaN(parseInt(a.data[i], 10))) {
          return a.data[i] > b.data[i] ? 1 : a.data[i] < b.data[i] ? -1 : 0;
        }

        return a.data[i] - b.data[i];
      }

      if (isNaN(parseInt(a.data[i], 10))) {
        return a.data[i] < b.data[i] ? 1 : a.data[i] > b.data[i] ? -1 : 0;
      }

      return b.data[i] - a.data[i];
    });
  }

  generateHeaderCell = (header, index) => {
    const headerCellClasses = classNames({
      'uni-data-table__cell-left': this.props.columnContentTypes[index] !== 'numeric',
      'uni-data-table__cell-right': this.props.columnContentTypes[index] === 'numeric',
      'uni-data-table__sortable-header':
        this.props.columnShowSortArrows && this.props.columnShowSortArrows[index],
    });

    let cellElement;

    switch (this.props.columnContentTypes[index]) {
      case 'selectmark':
        cellElement = (
          <SelectMark
            size={this.props.size === 'xsmall' ? 'small' : this.props.size}
            selectedState={
              this.props.rowsChecked.length > 0 && this.props.rowsChecked.length === this.props.rows.length
                ? 'selected'
                : 'unselected'
            }
            qaId={'row-selectmark-all-rows'}
            onClick={(e) => this.handleSelectMarkClick(e, 'all-rows-checked')}
          />
        );
        break;
      case 'numeric':
      case 'text':
        cellElement = (
          <span>
            {header}
            {this.props.columnShowSortArrows && this.props.columnShowSortArrows[index] && (
              <SortArrows
                sortDirection={this.state.sortedBy === index ? this.state.sortDirection : 'none'}
              />
            )}
          </span>
        );
        break;
      default:
        console.log('Sorry, incorrect column type');
    }

    return (
      <th
        className={headerCellClasses}
        role="columnheader"
        scope="col"
        key={index}
        aria-sort={
          this.state.sortedBy === index ? this.state.sortDirection : 'none'
        }
        onClick={
          (this.props.columnShowSortArrows && this.props.columnShowSortArrows[index])
            ? () => this.sortBy(index)
            : null
        }
      >
        {cellElement}
      </th>
    );
  }

  generateBodyCell = (row, cell, index) => {
    const bodyCellClasses = classNames({
      'uni-data-table__cell-left': this.props.columnContentTypes[index] !== 'numeric',
      'uni-data-table__cell-right': this.props.columnContentTypes[index] === 'numeric',
    });

    let cellElement;

    switch (this.props.columnContentTypes[index]) {
      case 'selectmark':
        const selectMarkEl = (
          <SelectMark
            size={this.props.size === 'xsmall' ? 'small' : this.props.size}
            selectedState={this.props.rowsChecked.includes(row.id) ? 'selected' : 'unselected'}
            qaId={`row-selectmark-${row.id}`}
            onClick={(e) => this.handleSelectMarkClick(e, row.id)}
          />
        );
        this.props.freezeFirst === 'column' && index < 1
          ? cellElement = (
            <th scope="row" key={index} className={bodyCellClasses}>
              {selectMarkEl}
            </th>
          ) : cellElement = (
            <td key={index} className={bodyCellClasses}>
              {selectMarkEl}
            </td>
          );
        break;
      case 'numeric':
      case 'text':
        this.props.freezeFirst === 'column' && index < 1 ?
          cellElement = (
            <th scope="row" key={index} className={bodyCellClasses}>
              {cell}
            </th>
          ) : cellElement = (
            <td key={index} className={bodyCellClasses}>
              {cell}
            </td>
          );
        break;
      default:
        console.log('Incorrect column type');
    }

    return cellElement;
  }

  handleRowClick = (e) => {
    const rowId = e.currentTarget.getAttribute('data-row-id');
    if (this.props.onRowClick) {
      this.props.onRowClick(rowId);
    }
  }

  handleSelectMarkClick = (e, id) => {
    e.stopPropagation();
    this.props.onSelectMarkClick(id);
  }

  render() {
    const dataTableClasses = classNames('uni-data-table', {
      [`uni-data-table--${this.props.style}`]: this.props.style,
      [`uni-data-table--${this.props.size}`]: this.props.size,
      'uni-data-table--is-rows-selectable': this.props.onRowClick,
      'uni-data-table--show-border': this.props.showTableBorder,
      [`uni-data-table--freeze-first-${this.props.freezeFirst}`]: this.props.freezeFirst,
    });

    return (
      <div className="uni-data-table__container" role="group">
        <table className={dataTableClasses}>
          <thead>
            <tr>
              {this.props.columnHeaders.map((header, i) => this.generateHeaderCell(header, i))}
            </tr>
          </thead>
          <tbody>
            {this.state.rows.map((row, i) => (
              <tr
                key={i}
                data-row-id={row.id}
                data-qa-id={`row-${row.id}`}
                className={this.props.rowsSelected.includes(row.id)
                  ? 'uni-data-table__row--selected' : null}
                onClick={this.handleRowClick}
              >
                {row.data.map((cell, j) => this.generateBodyCell(row, cell, j))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

DataTable.propTypes = {
  style: PropTypes.string,
  size: PropTypes.string,
  showTableBorder: PropTypes.bool,
  freezeFirst: PropTypes.oneOf(['row', 'column']),
  columnContentTypes: PropTypes.arrayOf(PropTypes.oneOf(['text', 'numeric', 'selectmark'])),
  columnShowSortArrows: PropTypes.arrayOf(PropTypes.bool),
  columnDefaultSortIndex: PropTypes.number,
  columnDefaultSortDirection: PropTypes.oneOf(['ascending', 'descending']),
  columnHeaders: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element])),
  rows: PropTypes.array,
  rowsChecked: PropTypes.array,
  rowsSelected: PropTypes.array,
  onSelectMarkClick: PropTypes.func,
  onRowClick: PropTypes.func,
};

DataTable.defaultProps = {
  style: 'default',
  size: 'medium',
  showTableBorder: false,
  freezeFirst: 'row',
  rowsSelected: [],
  rowsChecked: [],
};



// WEBPACK FOOTER //
// ./src/data-table/index.jsx